
      (function () {
        const searchParams = new URL(window.location.href).searchParams;
        const hasSensitiveGuestParams =
          searchParams.has('guest_token') ||
          searchParams.has('token') ||
          searchParams.has('resume_code');
        const programId = import.meta.env.VITE_PARTNERO_PROGRAM_ID;

        function loadScript(src) {
          const script = document.createElement('script');
          script.async = true;
          script.src = src;
          document.head.appendChild(script);
        }

        function loadCookieConsent() {
          loadScript(
            'https://gettermscmp.com/cookie-consent/embed/cc997091-62c1-4642-b397-3dda03abedfe/en-us?auto=true',
          );
        }

        function loadPartnero() {
          if (!programId) {
            return;
          }

          (function (p, t, n, e, r, o) {
            p.__partnerObject = r;
            function f() {
              const c = { a: arguments, q: [] };
              const m = this.push(c);
              return typeof m !== 'number' ? m : f.bind(c.q);
            }
            f.q = f.q || [];
            p[r] = p[r] || f.bind(f.q);
            p[r].q = p[r].q || f.q;
            o = t.createElement(n);
            const first = t.getElementsByTagName(n)[0];
            o.async = 1;
            o.src = e + '?v' + ~~(new Date().getTime() / 1e6);
            first.parentNode.insertBefore(o, first);
          })(
            window,
            document,
            'script',
            'https://app.partnero.com/js/universal.js',
            'po',
          );
          window.po('settings', 'assets_host', 'https://assets.partnero.com');
          window.po('program', programId, 'load');
        }

        function loadThirdPartyAssets() {
          if (window.__tovGuestThirdPartyLoaded) {
            return;
          }

          window.__tovGuestThirdPartyLoaded = true;
          loadCookieConsent();
          loadPartnero();
        }

        if (hasSensitiveGuestParams) {
          window.addEventListener(
            'tov:guest-access-cleared',
            () => {
              loadThirdPartyAssets();
            },
            { once: true },
          );
          return;
        }

        loadThirdPartyAssets();
      })();
    